import {MinimalStockRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export class MinimalStockRestDtoModel implements MinimalStockRestDto {
    min_stock?: number;

    constructor(min_stock: number | undefined) {
        this.min_stock = min_stock;
    }

    static createWithDefaults(): MinimalStockRestDtoModel{
        return new this(undefined);
    }
}
